import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { PRIOR_TO_ACTION_TYPE } from '../actions/priorTo.actions';

const initialState = [];

const priorToReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case PRIOR_TO_ACTION_TYPE.GET_PRIOR_TO_TYPES:
        return payload || initialState;

      case PRIOR_TO_ACTION_TYPE.ADD_PRIOR_TO_TYPE:
        draft.push(payload);
        break;

      case PRIOR_TO_ACTION_TYPE.UPDATE_PRIOR_TO_TYPE: {
        const index = draft.findIndex(({ id }) => id === payload.id);

        if (index !== -1) {
          draft[index] = payload;
        }

        break;
      }

      case PRIOR_TO_ACTION_TYPE.DELETE_PRIOR_TO_TYPE:
        return state.filter(({ id }) => id !== payload);

      case PRIOR_TO_ACTION_TYPE.REORDER_PRIOR_TO_TYPES:
        draft.forEach(item => {
          const index = payload.indexOf(item.id);

          if (index !== -1) {
            item.order = index + 1;
          }
        });
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default priorToReducer;
